/**
 *
 * @selector [data-js-autocomplete]
 * @enabled true
 */
import BaseModule from '../../modules/BaseModule.js';
import createAutocomplete from '../../../app/plugins/autocomplete.js';
import ky from 'ky';
import { makeCancelablePromise } from '../../../lib/util/makeCancelablePromise.js';
import Config from '../../../app/Config.js';

const DEFAULT_OPTIONS = {
    minLength: 3,
};

export default class Autocomplete extends BaseModule {
    init(element) {
        this.el = element;

        this.options = Object.assign({}, DEFAULT_OPTIONS, this.el.dataset.autocomplete);
        this.endpoint = this.el.dataset.endpoint;

        this.autocompleteInstance = createAutocomplete(this.el, (value, done) => this.onChange(value, done));

        return this;
    }

    onChange(value, done) {
        if (value.length < this.options.minLength) {
            this.autocompleteInstance.close();

            return;
        }

        return this.fetchAndRender(value, done);
    }

    async fetchAndRender(value, done) {
        try {
            const params = new URLSearchParams({
                [this.el.getAttribute('name')]: this.el.value,
            });

            const lang = this.el.getAttribute('data-language');
            params.set('lang', lang);

            const entries = await ky.get(`${this.endpoint}?${params}`).json();

            return done(entries);
        } catch (e) {
            console.log(e);
        }
    }

    destroy() {
        this.autocompleteInstance?.destroy();

        super.destroy();
    }
}
